import React from "react"
import { Toggle } from "material-ui"
import strings from "../../localization/strings"
import { IRoundingRuleItem, ERoundingMethod, IRoundingRulesSettings } from "../../models"
import AppStateStore from "../../stores/AppStateStore"
import _ from "lodash"
import AccountStore from "../../stores/AccountStore"
import * as utils from "../../helpers/utils"

interface IProps {
    readonly?: boolean
    isRoot?: boolean
    overridden?: boolean
    settingObj?: IRoundingRulesSettings
    handleChangeSettingObj?(settingObj: IRoundingRulesSettings): void
}

const HierarchySettingsRoundingRules: React.SFC<IProps> = (props: IProps) => {
    const twentyThreeMinuteCustomBreakRoundingRuleEnabled = AccountStore.getCustomRoundingRuleEnabled()
    const allowChange = (props.settingObj && props.settingObj.Use ? true : false) && (props.isRoot || props.overridden) && !props.readonly
    let roundingRules: IRoundingRuleItem[] = _.cloneDeep((props.settingObj && props.settingObj.RoundingRules) || [])
    const fifteenMinuteRoundingRule = roundingRules.some(i => i.RoundingMethod === ERoundingMethod.SevenMinuteRule)
    const sixMinuteRoundingRule = roundingRules.some(i => i.RoundingMethod === ERoundingMethod.ThreeMinuteRule)
    const oneMinuteRoundingRule = roundingRules.some(i => i.RoundingMethod === ERoundingMethod.OneMinuteRule)
    const twentyThreeMinuteCustomBreakRoundingRule = roundingRules.some(i => i.RoundingMethod === ERoundingMethod.TwentyThreeMinuteCustomBreakRoundingRule)

    const handleSave = (value: boolean, roundingMethod: ERoundingMethod) => {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_setting_of_hierarchy,
            confirm: () => {
                if (value) {
                    if (roundingMethod === ERoundingMethod.SevenMinuteRule) {
                        roundingRules = roundingRules.filter(i =>  ![ERoundingMethod.ThreeMinuteRule,ERoundingMethod.OneMinuteRule].includes(i.RoundingMethod))
                    }
                    else if (roundingMethod === ERoundingMethod.ThreeMinuteRule) {
                        roundingRules = roundingRules.filter(i =>  ![ERoundingMethod.SevenMinuteRule,ERoundingMethod.OneMinuteRule].includes(i.RoundingMethod) && i.RoundingMethod !== ERoundingMethod.TwentyThreeMinuteCustomBreakRoundingRule)
                    } 
                    else if (roundingMethod === ERoundingMethod.OneMinuteRule) {
                        roundingRules = roundingRules.filter(i => ![ERoundingMethod.SevenMinuteRule,ERoundingMethod.ThreeMinuteRule].includes(i.RoundingMethod) && i.RoundingMethod !== ERoundingMethod.SevenMinuteRule && i.RoundingMethod !== ERoundingMethod.TwentyThreeMinuteCustomBreakRoundingRule)
                    } 
                    roundingRules.push({
                        Id: utils.guid(),
                        Name: roundingMethod === ERoundingMethod.SevenMinuteRule ?
                            "FifteenMinuteRoundingRule" :
                            roundingMethod === ERoundingMethod.ThreeMinuteRule ?
                                "SixMinuteRoundingRule" :
                                roundingMethod === ERoundingMethod.TwentyThreeMinuteCustomBreakRoundingRule &&
                                "23Minute CustomBreakRoundingRule",
                        RoundingMethod: roundingMethod
                    })
                }
                else {
                    roundingRules = roundingRules.filter(i => i.RoundingMethod !== roundingMethod)
                    if (roundingMethod === ERoundingMethod.SevenMinuteRule) {
                        roundingRules = roundingRules.filter(i => i.RoundingMethod !== ERoundingMethod.TwentyThreeMinuteCustomBreakRoundingRule)
                    }
                }
                const { settingObj } = props
                settingObj.RoundingRules = roundingRules
                props.handleChangeSettingObj(settingObj)
            }
        })
    }

    return (
        <div>
            {allowChange ?
                <Toggle
                    data-intercom-target={"menu-Hierarchy-Settings-RoundingRules-Toggle-FifteenMinuteRoundingRule"}
                    label={strings.Fifteen_Minute_Rounding_Rule}
                    style={{ marginBottom: 20 }}
                    onToggle={(event, value) => handleSave(value, ERoundingMethod.SevenMinuteRule)}
                    toggled={fifteenMinuteRoundingRule}
                /> :
                <div style={{ marginBottom: 22, marginTop: 22 }}>
                    <span>{strings.Fifteen_Minute_Rounding_Rule}</span>
                    <span style={{ marginLeft: twentyThreeMinuteCustomBreakRoundingRuleEnabled ? 160 : 110 }}>{fifteenMinuteRoundingRule ? "True" : "False"}</span>
                </div>
            }
            {allowChange ?
                <Toggle
                    data-intercom-target={"menu-Hierarchy-Settings-RoundingRules-Toggle-SixMinuteRoundingRule"}
                    label={strings.Six_Minute_Rounding_Rule}
                    style={{ marginBottom: 20 }}
                    onToggle={(event, value) => handleSave(value, ERoundingMethod.ThreeMinuteRule)}
                    toggled={sixMinuteRoundingRule}
                /> :
                <div style={{ marginBottom: 22, marginTop: 22 }}>
                    <span>{strings.Six_Minute_Rounding_Rule}</span>
                    <span style={{ marginLeft: twentyThreeMinuteCustomBreakRoundingRuleEnabled ? 160 : 110 }}>{sixMinuteRoundingRule ? "True" : "False"}</span>
                </div>
            }
            {allowChange ?
                <Toggle
                    data-intercom-target={"menu-Hierarchy-Settings-RoundingRules-Toggle-OneMinuteRoundingRule"}
                    label={strings.One_Minute_Rounding_Rule}
                    style={{ marginBottom: 20 }}
                    onToggle={(event, value) => handleSave(value, ERoundingMethod.OneMinuteRule)}
                    toggled={oneMinuteRoundingRule}
                />
                 :
                <div style={{ marginBottom: 22, marginTop: 22 }}>
                    <span>{strings.One_Minute_Rounding_Rule}</span>
                    <span style={{ marginLeft: twentyThreeMinuteCustomBreakRoundingRuleEnabled ? 160 : 110 }}>{oneMinuteRoundingRule ? "True" : "False"}</span>
                </div>
            }
            {twentyThreeMinuteCustomBreakRoundingRuleEnabled && (
                allowChange ?
                    <Toggle
                        data-intercom-target={"menu-Hierarchy-Settings-RoundingRules-Toggle-TwentyThreeMinuteCustomBreakRoundingRule"}
                        label={strings.TwentyThreeMinute_Custom_Break_Rounding_Rule}
                        style={{ marginBottom: 20 }}
                        onToggle={(event, value) => handleSave(value, ERoundingMethod.TwentyThreeMinuteCustomBreakRoundingRule)}
                        toggled={twentyThreeMinuteCustomBreakRoundingRule}
                        disabled={props.readonly || !(props.isRoot || props.overridden) || !fifteenMinuteRoundingRule}
                    /> :
                    <div style={{ marginBottom: 22, marginTop: 22 }}>
                        <span>{strings.TwentyThreeMinute_Custom_Break_Rounding_Rule}</span>
                        <span style={{ marginLeft: 45 }}>{twentyThreeMinuteCustomBreakRoundingRule ? "True" : "False"}</span>
                    </div>
            )}
        </div>
    )
}

export default HierarchySettingsRoundingRules